<template>
  <v-card>
    <div class="top-row">
      <h4>Senaste statistiken</h4>
    </div>
               <div class="pa-3">
                 <v-alert
                       type="info"
                     >
                       Kommande funktion
                     </v-alert>
               </div>
    <!-- <iframe width="100%" height="800" src="https://datastudio.google.com/embed/reporting/b04a79b7-c468-4b51-9458-c844619de38d/page/1M" frameborder="0" style="border:0" allowfullscreen></iframe> -->
  </v-card>
</template>

<script>
export default {
  name: 'Statistics',
  props: {
    // Props
  },
  data() {
    return {
  
    }
  },
  computed: {

  },
  watch: {
    // Watch
  },
  methods: {},
  mounted() {
    // this.init()
  },
  beforeDestroy() {
    // BeforeDestroy
  },
}
</script>

<style lang="less" scoped>
.top-row {
  padding-left: 15px;
  padding-top: 12px;
}

</style>
